<template>
  <div class="atestado-card" :style="{ backgroundColor: $vuetify.theme.themes.light.soft }">
    <div class="icon-atestado" :style="{ backgroundColor: $vuetify.theme.themes.light.tertiary }">
      <v-icon color="primary">mdi-file-document-multiple-outline</v-icon>
    </div>
    <div class="d-flex flex-column">
      <span class="atestado-title">Você enviou um arquivo</span>
      <div class="d-flex flex-row mt-1">
        <div class="chip data-chip">
          <v-icon color="#339B41" size="15" class="mr-1">mdi-calendar-blank-outline</v-icon>
          {{ new Date(atestado.dtEmissao).toLocaleDateString('pt-br') }}
        </div>
        <div
          class="chip"
          :style="{
            backgroundColor: $vuetify.theme.themes.light.tertiary,
            color: $vuetify.theme.themes.light.secondary
          }"
        >
          <v-icon color="primary" size="15" class="mr-1">mdi-clock-time-three-outline</v-icon>
          {{ atestado.diasAfastamento }}
          {{ atestado.diasAfastamento === 1 ? 'dia de afastamento' : 'dias de afastamento' }}
        </div>
      </div>
    </div>
    <v-menu top>
      <template v-slot:activator="{ on, attrs }">
        <div class="actions-menu">
          <v-icon v-bind="attrs" v-on="on" color="#939396">mdi-dots-horizontal</v-icon>
        </div>
      </template>

      <v-list dense>
        <v-list-item link @click="editItem(atestado.id)">
          <v-list-item-icon>
            <v-icon color="primary">mdi-pencil-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Editar</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- <v-list-item link @click="removeItem(atestado.id)">
          <v-list-item-icon>
            <v-icon color="#FF0505">mdi-minus-circle-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Excluir</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'AtestadoCard',
  props: {
    atestado: {
      required: true
    }
  },
  methods: {
    editItem() {
      this.$emit('on-click-edit', this.atestado.id)
    }
  }
}
</script>

<style scoped>
.actions-menu {
  top: 0;
  right: 0;
  background-color: #fff;
  border-radius: 50%;
  cursor: pointer;
  margin-bottom: auto;
}
.actions-menu:hover {
  transform: scale(1.1);
}
.atestado-title {
  color: #939396;
}
.atestado-card {
  padding: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: center;
  justify-content: center;
  margin-bottom: 30px;
}
.icon-atestado {
  width: 55px;
  height: 55px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-content: center;
  margin-right: 4vw;
}
.chip {
  display: flex;
  flex-direction: row;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  border-radius: 50px;
  font-size: 0.7rem;
  padding: 2px 6px;
  font-weight: 600;
  margin-right: 10px;
}
.data-chip {
  background-color: #cee8db;
  color: #339b41;
}
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 10px !important;
}
</style>
